import pages from './seo-pages.json';

export const SITE_URL = 'https://itansar.ru';
export const SEO_PAGES = pages;
export type SeoPageData = typeof pages[number];

export const findSeoPage = (pathname: string) => {
    const normalized = pathname.replace(/\/+$/, '') || '/';
    return SEO_PAGES.find(page => (page.path.replace(/\/+$/, '') || '/') === normalized);
};

export const structuredDataFor = (page: SeoPageData) => {
    const url = SITE_URL + page.path;
    const organizationId = `${SITE_URL}/#organization`;
    const organization = {
        '@type': 'EducationalOrganization', '@id': organizationId,
        name: 'Школа программирования Ансар', alternateName: ['Ансар', 'Ansar', 'itansar'],
        legalName: 'Индивидуальный предприниматель Гелдабаев Юнус Исхакович',
        url: `${SITE_URL}/`, image: `${SITE_URL}/og-image.png`,
        telephone: '+79953334456', email: 'yunus.geldabaev@gmail.com',
        address: {
            '@type': 'PostalAddress', streetAddress: 'ул. Сайханова, зд. 29А',
            addressLocality: 'Грозный', addressRegion: 'Чеченская Республика', addressCountry: 'RU'
        },
        sameAs: ['https://t.me/ansarium', 'https://instagram.com/ansar_itcompany']
    };
    const graph: object[] = [organization, {
        '@type': 'WebSite', '@id': `${SITE_URL}/#website`, url: `${SITE_URL}/`,
        name: 'Школа программирования Ансар', alternateName: ['Ансар', 'itansar'],
        inLanguage: 'ru-RU', publisher: { '@id': organizationId }
    }, {
        '@type': page.kind === 'contacts' ? 'ContactPage' : page.kind === 'catalog' ? 'CollectionPage' : 'WebPage',
        '@id': `${url}#webpage`, url, name: page.title, description: page.description,
        inLanguage: 'ru-RU', isPartOf: { '@id': `${SITE_URL}/#website` },
        about: { '@id': organizationId }
    }];
    if (page.path !== '/') {
        const crumbs = [{ name: 'Главная', item: `${SITE_URL}/` }];
        if (page.kind === 'course') crumbs.push({ name: 'Курсы', item: `${SITE_URL}/courses/` });
        crumbs.push({ name: page.label, item: url });
        graph.push({
            '@type': 'BreadcrumbList', '@id': `${url}#breadcrumbs`,
            itemListElement: crumbs.map((crumb, i) => ({ '@type': 'ListItem', position: i + 1, ...crumb }))
        });
    }
    const coursePages = page.kind === 'course' ? [page] : page.kind === 'home' || page.kind === 'catalog'
        ? SEO_PAGES.filter(item => item.kind === 'course') : [];
    coursePages.forEach(course => graph.push({
        '@type': 'Course', '@id': `${SITE_URL}${course.path}#course`,
        url: SITE_URL + course.path, name: course.label, description: course.description,
        provider: { '@id': organizationId }, inLanguage: 'ru-RU'
    }));
    if (coursePages.length > 1) graph.push({
        '@type': 'ItemList', '@id': `${url}#courses`, name: 'Курсы школы Ансар',
        itemListElement: coursePages.map((course, i) => ({
            '@type': 'ListItem', position: i + 1, url: SITE_URL + course.path
        }))
    });
    return { '@context': 'https://schema.org', '@graph': graph };
};
